export const messages = {
  en: {
    distributionMode: {
      modeType: 'Mode Type',
      selectMode: 'Please select distribution mode',
      fixedFee: 'Fixed Fee',
      modeName: 'Mode Name',
      modeNamePlaceholder: 'Required, please enter mode name',
      fixedFeePlaceholder: 'Required, please enter fixed fee',
      startDeliveryIn: 'Start Delivery Within 1km',
      startDeliveryInPlaceholder: 'Required, please enter amount within 1km',
      startDeliveryOut: 'Start Delivery After 1km',
      startDeliveryOutPlaceholder: 'Required, please enter amount after 1km',
      maximumDistribution: 'Maximum Delivery Distance',
      maximumDistributionPlaceholder: 'Required, please enter maximum distance',
      modeNameRequired: 'Mode name is required',
      modeNameMaxLength: 'Mode name cannot exceed 30 characters',
      modeIdRequired: 'Mode ID is required',
      modeIdMaxLength: 'Mode ID cannot exceed 30 characters',
      deleteTitle: 'Please confirm your operation!',
      deleteConfirm: 'Are you sure to delete this distribution mode?',
      addSuccess: 'Added successfully',
      editSuccess: 'Modified successfully',
      deleteSuccess: 'Deleted successfully',
      deliveryType: 'Delivery Type',
      deliveryTypeStore: 'Store Delivery',
      deliveryTypeProperty: 'Property Delivery',
      selectDeliveryType: 'Please select delivery type',
      deliveryTypeRequired: 'Delivery type is required'
    },
    common: {
      cancel: 'Cancel',
      confirm: 'Confirm'
    }
  },
  zh: {
    distributionMode: {
      modeType: '选择方式',
      selectMode: '请选择派单方式',
      fixedFee: '固定费',
      modeName: '方式名称',
      modeNamePlaceholder: '必填，请填写方式名称',
      fixedFeePlaceholder: '必填，请填写固定费',
      startDeliveryIn: '起送1公里内',
      startDeliveryInPlaceholder: '必填，请填写起送1公里内',
      startDeliveryOut: '起送1公里后每公里',
      startDeliveryOutPlaceholder: '必填，请填写起送1公里后每公里',
      maximumDistribution: '最大配送公里',
      maximumDistributionPlaceholder: '必填，请填写最大配送公里',
      modeNameRequired: '方式名称不能为空',
      modeNameMaxLength: '方式名称不能超过30个字符',
      modeIdRequired: '派送方式ID不能为空',
      modeIdMaxLength: '派送方式ID不能超过30个字符',
      deleteTitle: '请确认您的操作!',
      deleteConfirm: '确定删除派送方式吗?',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      deliveryType: '配送类型',
      deliveryTypeStore: '商家自配送',
      deliveryTypeProperty: '物业配送',
      selectDeliveryType: '请选择配送类型',
      deliveryTypeRequired: '配送类型不能为空'
    },
    common: {
      cancel: '取消',
      confirm: '确定'
    }
  }
}